// Pontuação (rating) de um jogador: totalPoints (0-100) ou,
// em registros antigos, vitórias - derrotas.
export const getPlayerPoints = (p) => p.totalPoints ?? (p.wins - p.losses);

export const sumPoints = (players) => players.reduce((sum, p) => sum + getPlayerPoints(p), 0);
